'use client'

import { useEffect, useState } from 'react'
import { usePathname } from 'next/navigation'

type PayloadPageEditLinkProps = {
  pageId: string
}

const EDIT_COOKIE_NAME = 'payload_can_edit_pages'

function canEditFromCookie() {
  return document.cookie
    .split('; ')
    .some((cookie) => cookie === `${EDIT_COOKIE_NAME}=1`)
}

export function PayloadPageEditLink({ pageId }: PayloadPageEditLinkProps) {
  const [canEdit, setCanEdit] = useState(false)
  const pathname = usePathname() || '/'
  const isDraftMode = pathname === '/preview' || pathname.startsWith('/preview/')
  const draftModeHref = isDraftMode
    ? pathname.replace(/^\/preview(?=\/|$)/, '') || '/'
    : pathname === '/'
      ? '/preview'
      : `/preview${pathname}`

  useEffect(() => {
    setCanEdit(canEditFromCookie())
  }, [])

  if (!canEdit) return null

  return (
    <div className="fixed bottom-6 right-6 z-[60] flex items-center gap-2">
      <a
        href={draftModeHref}
        className="rounded-md border border-black bg-white px-4 py-2 text-sm font-medium text-black shadow-lg transition-opacity hover:opacity-90"
      >
        {isDraftMode ? 'Disable Draft' : 'Enable Draft'}
      </a>
      <a
        href={`/admin/collections/pages/${pageId}`}
        className="rounded-md bg-black px-4 py-2 text-sm font-medium text-white shadow-lg transition-opacity hover:opacity-90"
      >
        Edit page
      </a>
    </div>
  )
}
